export default __webpack_public_path__ + "static/bg1-5fd009a4e52dad13d6506ca509e66382.png";